import { Components } from '@mui/material';

export const MuiTableContainerTheme: Components['MuiTableContainer'] = {
  styleOverrides: {
    root: {
      boxShadow: 'none',
    },
  },
};
